// <div data-controller="components--clipboard">
//     <div class="btn btn-primary"
//         id="copyAction"
//         data-target="components--clipboard.copyText"
//         data-clipboard-text="<%= "#{request.base_url}/#{current_user.username}" %>"
//         data-action="click->components--clipboard#onClickCopy">복사하기
//     </div>
// </div>
import { Controller } from "@hotwired/stimulus";
import ClipboardJS from 'clipboard';
import { createFlash } from "@/utils/flash";
import { t } from "@/utils/i18n";

export default class extends Controller {
  static targets = [ "copyText"];

  connect() {
    this.clipboard = new ClipboardJS(this.copyTextTarget);
    this.clipboard.on("success", (e) => {
      const containsHTML = /<\/?[a-z][\s\S]*>/i.test(e.text); // HTML 태그 포함 여부 확인
      // 여러 줄이거나 긴 값(연결 명령, JSON 설정 등)은 그대로 띄우면 플래시가 화면을 덮는다.
      const tooLongToEcho = e.text.includes("\n") || e.text.length > 60;

      const message = containsHTML || tooLongToEcho
          ? t("clipboard.copied_generic", "선택하신 값이 클립보드에 복사되었습니다.")
          : t("clipboard.copied_value_html", "<b>%{value}</b> 값이 클립보드에 복사되었습니다.").replace("%{value}", e.text);

      createFlash({
        key: "check",
        ttl: 2,
        message: message,
        stack: false
      });
    });
  }


  disconnect() {
    this.clipboard.destroy()
  }
}